import { createContext, useContext, useState } from 'react'
import { MetaverseNames } from 'types/Metaverse'

import { MakeAllOptional } from 'types/helpers'

const FormDataContext = createContext<any>(null)

export const CreateAdSpotFormDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [data, setData] = useState<ContextType>({
    name: '',
    description: '',
    moderationEnabled: false,
    files: [],
    metaverseType: 'Decentraland',
    size: {value: 0, label: '1920x1080'}
  })

  const setValues = (values: MakeAllOptional<ContextType>) => {
    setData((prevData: ContextType) => ({
      ...prevData,
      ...values,
    }))
  }

  return <FormDataContext.Provider value={{ data, setValues }}>{children}</FormDataContext.Provider>
}

export const useData = () => useContext<IUseData>(FormDataContext)

interface IUseData {
  data: ContextType
  setValues: (val: MakeAllOptional<ContextType>) => void
}

interface ContextType {
  name: string
  description: string
  moderationEnabled: boolean
  metaverseType: MetaverseNames
  files: File[]
  size?: {value: number, label: string}
  uuid?: string
  type?: {value: number, label: string}
  jumpUrl?: string
  externalLink?: string | null
  defaultMedia?: string | null
  defaultMediaFilename?: string | null
}
